
import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
} from "react-share";
import Icon from '@mdi/react';
import { useStaticQuery, graphql } from "gatsby"
import { mdiFacebook, mdiLinkedin, mdiEmail, mdiLinkBoxVariant } from '@mdi/js';

const SocialShare = (props) => {
  const [isOpen, setIsOpen] = useState(false)

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            url
          }
        }
      }
    `
  )

  const url = site.siteMetadata.url + '/survey/2024#' + props.sectionId

  function handleClick() {
    if (!isOpen) {
      setIsOpen(true)
    } else {
      setIsOpen(false)
    }
  }

  return (
    <div className="social-share">
      <button className="button is-small is-family-sans-serif is-uppercase social-share-button" onClick={handleClick}>
        <span>Share</span>
      </button>

      {isOpen &&

        <div className="social-share-roll">
          <EmailShareButton
            url={url}
            className="mx-1 animate-button"
            subject={site.siteMetadata.title + ' for "' + props.sectionTitle +'"'}
          >
            <Icon path={mdiEmail} size={1.2} title="Share result as email" />
          </EmailShareButton>

          <a href={`#${props.sectionId}`} className="has-text-grey-dark mx-1 animate-button">
            <Icon path={mdiLinkBoxVariant} size={1.2} title="Link to section" />
          </a>

          <FacebookShareButton
            className="mx-1 animate-button"
            url={url}
            quote={site.siteMetadata.title + ' for "' + props.sectionTitle +'"'}
            hashtag='#RailsSurvey2024'
          >
            <Icon path={mdiFacebook} size={1.2} title="Share result on Facebook" />
          </FacebookShareButton>

          <LinkedinShareButton
            url={url}
            className="mx-1 animate-button"
            source={site.siteMetadata.title}
            title={props.sectionTitle}
            summary={site.siteMetadata.description}
          >
            <Icon path={mdiLinkedin} size={1.2} title="Share on LinkedIn" />
          </LinkedinShareButton>

          <TwitterShareButton
            className="mx-1 animate-button"
            url={url}
            title={site.siteMetadata.title + ' for "' + props.sectionTitle +'"'}
            via={site.siteMetadata.author}
            hashtags={['RailsSurvey2024']}
          >
            <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" style={{ width: '1.8rem', height: '1.8rem' }}><path d="m10.4 10 5.3 6.9h.8l-5.2-6.9z" style={{ fill: 'currentColor' }}/><path d="m13.5 2.2c-6.2 0-11.3 5.1-11.3 11.3s5 11.2 11.2 11.2 11.2-5 11.2-11.2-4.9-11.3-11.1-11.3zm1.8 15.6-2.3-3-2.6 3h-1.5l3.4-3.9-3.6-4.7h3l2.1 2.8 2.4-2.8h1.5l-3.2 3.7 3.8 5h-3z" style={{ fill: 'currentColor' }}/></svg>
          </TwitterShareButton>
        </div>
      }
    </div>
  )
}

SocialShare.propTypes = {
  sectionId: PropTypes.string,
  sectionTitle: PropTypes.string,
}

SocialShare.defaultProps = {
  sectionId: "",
  sectionTitle: "",
}

export default SocialShare